import React from "react";
import { connect } from "react-redux";
import { goToTeacherPortal } from "../../../../redux/navigation/actions";
import GoTo from "./go-to";

const TeacherView = ({ goToPortal }) => (
  <GoTo
    buttonText="teacher-portal.go-to-teacher-portal"
    description="teacher-portal.explore"
    onClick={goToPortal}
  />
);

export default connect(
  null,
  dispatch => ({
    goToPortal: () => dispatch(goToTeacherPortal())
  })
)(TeacherView);
